import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AbstractSelect } from '@components/field_form/selects/abstract-select';
import { AbstractClass } from '@classes/abstract.class';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { WorkScheduleTypeService } from '@services/admin/work-schedule-type.service';

@Component({
  standalone: false,
  selector: 'app-field-form-select-work-schedule-type',
  templateUrl: './select-work-schedule-type.component.html',
  styleUrls: ['./select-work-schedule-type.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'overlay_custom_select' }
    }
  ]
})
export class SelectWorkScheduleTypeComponent extends AbstractSelect implements OnInit {
  @Input() public myClass: AbstractClass | null = null;
  @Input() label = '';
  @Input() name = '';
  @Input() required = false;
  @Input() filter = false;

  public list: any[] = [];
  public selectTemporal: any[] = [];

  constructor(
    public service: WorkScheduleTypeService
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.loadData();
  }

  public loadData = () => {
    this.service.getAllActive().then(
      (data) => {
        if (data === true) {
          this.list = this.service.data.data;
        }
      }
    );
  }
}
